module.exports = __webpack_public_path__ + "img/8.f4e4787a.png";